import Api from '../api/reconApi.js';
import * as getInfo from './apiGetInfo';

export function addFeedDispatch(data, errorType) {
	if (data.id) {
		return dispatch => Api.patchData(`feed_dispatches/${data.id}`, data).then(() => dispatch(getInfo.getFeedDispatches())).catch(ex => Api.handleApiError(ex, errorType));
	}
	return dispatch => Api.postData('feed_dispatches/', data).then(() => dispatch(getInfo.getFeedDispatches())).catch(ex => Api.handleApiError(ex, errorType));
}

export function updateFeedDispatch(id, data, errorType) {
	return dispatch => Api.patchData(`feed_dispatches/${id}`, data).then(() => {
		dispatch(getInfo.getFeedDispatches());
		return 'success';
	}).catch(ex => Api.handleApiError(ex, errorType));
}

export function deleteFeedDispatch(id, errorType) {
	return dispatch => Api.delete(`feed_dispatches/${id}`).then(() => {
		dispatch(getInfo.getFeedDispatches());
		return 'success';
	}).catch(ex => Api.handleApiError(ex, errorType));
}

export function persistDispatchOrder(updates, errorType) {
	// Stops at the first failed PATCH and refetches, so the list shows what the
	// API actually saved instead of continuing with a half-applied order.
	return async (dispatch) => {
		for (let i = 0; i < updates.length; i++) {
			try {
				await Api.patchData(`feed_dispatches/${updates[i].id}`, updates[i].data);
			} catch (ex) {
				Api.handleApiError(ex, errorType);
				break;
			}
		}
		return dispatch(getInfo.getFeedDispatches());
	};
}

export function cloneFeedDispatch(source, dealerships, errorType) {
	return async (dispatch) => {
		const targets = dealerships || [];
		for (let i = 0; i < targets.length; i++) {
			const payload = {
				name: source.name,
				dealership: targets[i],
				dispatch_type: source.dispatch_type || 'feed_automove',
				priority: Number(source.priority) || 0,
				enabled: source.enabled !== false,
				match_mode: source.match_mode || 'all',
				note: source.note || null,
				target_department_id: source.target_department_id != null ? source.target_department_id : null,
				target_setting: source.target_setting || null,
				feed_dispatch_rules_attributes: (source.feed_dispatch_rules || []).map((r, idx) => {
					const attr = {
						source: r.source, operator: r.operator, value: r.value || '', position: r.position != null ? r.position : idx,
					};
					if (r.value_type) attr.value_type = r.value_type;
					return attr;
				}),
			};
			await Api.postData('feed_dispatches/', payload).catch(ex => Api.handleApiError(ex, errorType));
		}
		return dispatch(getInfo.getFeedDispatches());
	};
}
